export default __webpack_public_path__ + "static/media/icon-error.ea541604.svg";